import React from 'react';

const clean = (value) => String(value ?? '').trim();

export function optionSymbolParts({ symbol, strike, optionType, underlying } = {}) {
  const raw = clean(symbol);
  const typeFromSymbol = raw.match(/\s*(CE|PE)$/i)?.[1]?.toUpperCase() || '';
  const type = clean(optionType).toUpperCase() || typeFromSymbol;
  const numericStrike = Number(strike);
  let strikeText = strike !== undefined && strike !== null && clean(strike) !== '' && Number.isFinite(numericStrike) && numericStrike !== 0
    ? String(numericStrike)
    : '';
  if (!strikeText && type) {
    const match = raw.match(/(\d+(?:\.\d+)?)\s*(?:CE|PE)$/i);
    if (match) strikeText = String(Number(match[1]));
  }
  let base = clean(underlying);
  if (!base) {
    base = raw
      .replace(/\s*\d+(?:\.\d+)?\s*(?:CE|PE)$/i, '')
      .replace(/\d{2}[A-Z]{3}$/i, '')
      .replace(/\d{2}[A-Z]{3}\d+(?:CE|PE)$/i, '')
      .replace(/\d{2}[A-Z]{3}\d+$/i, '')
      .trim();
    if (!base || base === raw) base = raw.replace(/\d+(?:\.\d+)?\s*(?:CE|PE)$/i, '').trim();
  }
  const isOption = (type === 'CE' || type === 'PE') && !!strikeText;
  return { base: base || raw || '—', strikeText, optionType: type, isOption };
}

export default function OptionSymbol({ symbol, strike, optionType, underlying, className = '' }) {
  const parts = optionSymbolParts({ symbol, strike, optionType, underlying });
  if (!parts.isOption) return <span className={`option-symbol-name ${className}`.trim()}>{clean(symbol) || '—'}</span>;
  return (
    <span className={`option-symbol-name ${className}`.trim()}>
      <span className="option-symbol-underlying">{parts.base}</span>
      <span className={`option-symbol-contract ${parts.optionType.toLowerCase()}`}>{parts.strikeText} {parts.optionType}</span>
    </span>
  );
}
